import styled from '@emotion/styled'

import { SelectMenu } from 'components/patterns/Inputs'
import PowerNetLevelEditor from '../PowerNetLevelEditor'

export const StyledOutputSelectMenu = styled(SelectMenu)`
  .ant-select {
    width: 100%;
  }
`

export const StyledPowerNetLevelEditor = styled(PowerNetLevelEditor)`
  .ant-select {
    width: 214px;
  }
`
